import { graphql } from 'services/api';
import { GET_PAGES } from 'graphqlQueriesAndMutations/queries';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';

export async function getDynamicShowCase(
	setListMenuItensLocation: React.Dispatch<
		React.SetStateAction<DynamicShowCaseProps[]>
	>,
	setActualPage: React.Dispatch<React.SetStateAction<number>>,
	setTotalPages: React.Dispatch<React.SetStateAction<number>>,
	actualPage: number,
	handleNotify: any
) {
	try {
		const { data } = await graphql.query({
			query: GET_PAGES,
			variables: { limit: 20, page: actualPage },
			fetchPolicy: 'no-cache'
		});

		setListMenuItensLocation(data?.pagesPaginated?.data || []);
		setActualPage(data?.pagesPaginated?.page || 1);
		setTotalPages(data?.pagesPaginated?.totalPages || 1);
	} catch (error: any) {
		handleNotify(
			error?.message || 'Erro ao buscar as vitrines dinâmicas',
			'error'
		);
	}
}
